import { render, staticRenderFns } from "./ModPaymentReceipt.vue?vue&type=template&id=07db1813&scoped=true"
import script from "./ModPaymentReceipt.vue?vue&type=script&lang=ts"
export * from "./ModPaymentReceipt.vue?vue&type=script&lang=ts"
import style0 from "./ModPaymentReceipt.vue?vue&type=style&index=0&id=07db1813&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07db1813",
  null
  
)

export default component.exports